/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Slice {
  /**
   * Slice an array at indices
   *
   * @public
   * @function f1.slice
   * @see f1.cut to copy a string
   * @param start the first index which is bounded by 0
   * @param end the index above the last index, and negative values wrap
   * @param arr the array to slice
   * @example
   *
   * ```ts
   * f1.slice(1, 3, [1, 2, 3, 4]) => [2, 3]
   * ```
   *
   */
  <T>(start: number, end: number, arr: T[]): T[];
  <T>(start: number, end: number): (arr: T[]) => T[];
}

/**
 * @see Slice
 */
export default <T>(start: number, end: number, arr: T[]): T[] => {
  return arr.slice(Math.max(start, 0), end);
};
